import { useTranslation } from 'react-i18next';

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import Button from '@appchoose/button';
import { BarChart3 } from 'lucide-react';

interface CompareOffersButtonProps {
  onClick: () => void;
  /** Set false when the label is visible (no redundant tooltip). */
  showTooltip?: boolean;
}

export function CompareOffersButton({
  onClick,
  showTooltip = true,
}: CompareOffersButtonProps) {
  const { t } = useTranslation();
  const label = t('components.other.analyze');
  const button = (
    <Button
      type="button"
      onClick={onClick}
      appearance="outline"
      className="box-border flex h-10 items-center gap-2 border border-gray-300 px-3 py-0 font-medium"
    >
      <BarChart3 className="size-4 shrink-0" />
      <span className="hidden whitespace-nowrap @header-button-choose:inline">
        {label}
      </span>
    </Button>
  );

  if (!showTooltip) {
    return button;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>{button}</TooltipTrigger>
      <TooltipContent side="bottom">{label}</TooltipContent>
    </Tooltip>
  );
}
